/**
 * Woran der Start gescheitert ist — am Netz oder an der Sitzung
 * (A-10-Nebenbefund, Nachprüfung 03.10.2026).
 *
 * Fiel das Netz **während** des Starts weg — `POST /api/kontext` kam noch
 * durch, `GET /api/ich` nicht —, galt das als „keine Sitzung": Die Anmeldung
 * stand da und blieb stehen, auch als das Netz zurück war, bis jemand neu
 * lud. Nachgeholt wurde nur, wenn schon der Kontext am Netz scheiterte (T-41).
 * Jetzt heißt ein Netzfehler an jeder Stelle des Starts „nachholen, sobald
 * das Netz zurück ist" (`schale/Sitzung.tsx`).
 *
 * Ohne Abhängigkeiten, damit es sich ohne Browser prüfen lässt; der Fehler der
 * Anwendung (`daten/klient.ts`, `Fehler("netz", 0)`) wird an seiner Form
 * erkannt.
 */
export function startausgangBeiFehler(e: unknown): "aus" | "netz" {
  if (typeof e !== "object" || e === null) return "aus";
  const f = e as { schluessel?: unknown; status?: unknown; name?: unknown };
  if (f.schluessel === "netz" || f.status === 0) return "netz";
  // `fetch` selbst wirft im Funkloch einen TypeError, bevor `klient.ts` ihn fasst.
  if (f.name === "TypeError" && f.schluessel === undefined) return "netz";
  return "aus";
}
